import { useState, useEffect, useRef } from "react";

import useFetch from "shared/model/useFetch";
import useAlertModalAtom from "shared/model/useAlertModalAtom";
import exportFileType from "shared/lib/fileTypeExtractor";

const useLogoUpload = (initImgUrl) => {
  const [imgUrl, setImgUrl] = useState(initImgUrl);

  const [fetchResult, fetchRequest] = useFetch();
  const [, setAlert] = useAlertModalAtom();
  const imgUrlRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setImgUrl(initImgUrl);
  }, [initImgUrl]);

  useEffect(() => {
    if (imgUrl) {
      imgUrlRef.current = imgUrl;
    }
  }, [imgUrl]);

  const uploadImage = async (imgFile) => {
    if (!["jpg", "png"].includes(exportFileType(imgFile.name).toLowerCase())) {
      setAlert("jpg, png 이미지만 업로드 가능합니다.");
      return;
    }
    if (Math.round(imgFile.size) > 20 * 1024 * 1024) {
      setAlert("20mb 이하 이미지만 업로드 가능합니다.");
      return;
    }

    setLoading(true);
    try {
      const formdata = new FormData();
      formdata.append("src", imgFile);
      await fetchRequest("POST", "/admin/util/upload", null, formdata);
    } catch (error) {
      console.log("🚀~error :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    switch (fetchResult?.statusCode) {
      case 400:
        if (fetchResult?.data?.error_code === "src")
          setAlert("이미지의 확장자와 용량을 확인해 주세요.");
        else setAlert("입력한 값의 형식이 잘못되었습니다.");
        break;
      default:
        break;
    }

    if (fetchResult?.data?.path) {
      setImgUrl(fetchResult?.data?.path);
    }
  }, [fetchResult]);

  return { uploadImage, imgUrl, imgUrlRef, loading };
};

export default useLogoUpload;
